<script lang="ts">
  import { Button, Form, FormGroup, Input, Row } from "sveltestrap";
  import { InlineFormwithoutLabel, Login } from "../../../../utils/Constant/Constant";
</script>

<h6>{InlineFormwithoutLabel}</h6>
<Form class="row-cols-sm-3 theme-form mt-3 form-bottom">
    <Row>
        <FormGroup class="d-flex">
            <Input
            type="text"
            name="inputUnlabelUsername"
            placeholder="Username"
            autocomplete="off"
            />
        </FormGroup>
        <FormGroup class="d-flex">
            <Input
            id="inputUnlabelPassword"
            type="password"
            name="inputPassword"
            placeholder="Password"
            autocomplete="off"
            />
        </FormGroup>
        <FormGroup class="d-flex">
            <Button color="secondary">{Login}</Button>
        </FormGroup>
    </Row>
</Form>
